import React from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'
import { Heading, ModalBody, ModalFooter, SubmitButton, Text, Notification, useMediaQuery } from '@offerzen/pinata'

import ResponsiveModal from '@/CandidateExperience/components/ResponsiveModal'

import styles from './styles'

const ApplyModal = ({
  showModal,
  hideModal,
  companyName,
  positionName,
  isSubmittingApplication,
  submitApplication,
  isApplicationError,
}) => {
  const { isTabletOrLarger } = useMediaQuery()

  return createPortal(
    <ResponsiveModal size="default" isTabletOrLarger={isTabletOrLarger} showModal={showModal} resetModal={hideModal}>
      <ModalBody>
        <article>
          <Text>
            <Heading className={styles.heading}>
              Apply for the {positionName} at {companyName}
            </Heading>
            <p>Once you’ve applied we will notify the company and they will review your application.</p>
          </Text>

          <If condition={isApplicationError}>
            <Notification theme="error">
              <div role="alert">Something went wrong. Please try again.</div>
            </Notification>
          </If>

          <ModalFooter size={isTabletOrLarger && 'large'} onCancel={hideModal}>
            <SubmitButton
              submitLabel="Send my application"
              submittingLabel="Sending application"
              size="medium"
              isSubmitting={isSubmittingApplication}
              onClick={submitApplication}
            />
          </ModalFooter>
        </article>
      </ModalBody>
    </ResponsiveModal>,
    document.getElementById('react-modal'),
  )
}

ApplyModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  companyName: PropTypes.string.isRequired,
  positionName: PropTypes.string.isRequired,
  isSubmittingApplication: PropTypes.bool,
  submitApplication: PropTypes.func.isRequired,
  isApplicationError: PropTypes.bool,
}

export default ApplyModal
